import { useState } from 'react';
import { csvTextToArray, convertToCSVFriendly } from '../utils/templateFormCsv';

const useCSVHandler = () => {
    const [importedData, setImportedData] = useState<any[]>([]);
    const [isLoadingImport, setIsLoadingImport] = useState(false);

    const importCSV = (file: File, processCSVData: (csvArray: string[][]) => any[]) => {

        const reader = new FileReader();
        reader.onloadend = () => {
            const csvText = reader.result?.toString();
            if (csvText) {
                const csvArray = csvTextToArray(csvText);
                const importedFields = processCSVData(csvArray);
                setImportedData(importedFields);
            }
        };

        reader.readAsText(file);
    };

    const exportCSV = (data: any[], headers: string[], filename: string) => {
        let csvContent = `${headers.map(header => convertToCSVFriendly(header)).join(',')}\n`;

        data.forEach(item => {

            if (item?.associatedVariable?.length && item?.associatedVariable === item?.value) {
                return; // don't want shared topics fields that are marked as location specific in export
            } else if (item?.associatedVariable?.length && item?.associatedVariable !== item?.value) {
                delete item.associatedVariable;
            }

            // Use headers to ensure column order matches
            const row = headers.map(header => {
                const value = item[header];
                return convertToCSVFriendly(value != null ? String(value) : '', header === 'isRequired');
            }).join(',');

            csvContent += row + '\n';

        });


        const bom = '\uFEFF';
        const blob = new Blob([bom + csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.setAttribute('href', url);
        link.setAttribute('download', `${filename}.csv`);
        document.body.appendChild(link);
        link.click();
        link.remove();

    };


    return {
        importedData,
        isLoadingImport,
        setIsLoadingImport,
        importCSV,
        exportCSV
    };
};

export default useCSVHandler;
